import { createSlice } from "@reduxjs/toolkit";
import { defaultLang, defaultCulture, supportedLangs, supportedCultures } from "../../config/i18nConfig";

const initialState = {
  lang: defaultLang,
  culture: defaultCulture,
  supportedLangs: { ...supportedLangs },
  supportedCultures: { ...supportedCultures },
  translations: {},
  translationsLoaded: false,
};

export const i18nSlice = createSlice({
  name: "i18n",
  initialState,
  reducers: {
    setLang: (state, action) => {
      if(state.lang === action.payload)
        return;
      state.lang = action.payload;
      state.translations = {};
      state.translationsLoaded = false;
    },
    setTranslations: (state, action) => {
      state.translations = action.payload;
      state.translationsLoaded = true;
    },
    addTranslation: (state, action) => {
      state.translations = { ...state.translations, ...action.payload };
    },
    setCulture: (state, action) => {
      state.culture = action.payload;
    },
    setTranslationsLoaded: (state, action) => {
      state.translationsLoaded = action.payload;
    },
  },
});

export const { setLang, setCulture, setTranslations, addTranslation, setTranslationsLoaded } = i18nSlice.actions;

export default i18nSlice.reducer;